import { type ApiClientResponse, nodeApiClient, nodeApiRoutes } from 'common/services';
import type { PaginatedDataObjects, ReleaseNotesDataObject } from 'models/service';

type ReleaseNotesRequest = {
  $limit: number;
  $skip?: number;
  platform: 'android' | 'fe' | 'ios';
};

export const getReleaseNotes = async (params: ReleaseNotesRequest) =>
  nodeApiClient.get<
    PaginatedDataObjects<ReleaseNotesDataObject>,
    ApiClientResponse<PaginatedDataObjects<ReleaseNotesDataObject>>
  >(nodeApiRoutes.releaseNotes.find, { params });
